import React from 'react';
import Box from '@material-ui/core/Box';

import { SectionWrapper } from '../../_core/_ui/structure.components';
import { SectionHeading, Text } from '../../_core/_ui/typography.component';
import { MARKETING_CONTACT_URL } from '../../../../_configuration';

export const ParentDashboardEmptyState: React.FC = () => (
  <SectionWrapper>
    <SectionHeading>We couldn&apos;t find any players linked to you yet</SectionHeading>
    <Text>
      We match players to you using the email and phone number your association has on file.
      If your contact details differ from what your association recorded, your players won&apos;t appear here.
    </Text>
    <Box mt={2}>
      {/* Marketing-site contact form is the canonical support channel here. */}
      <a href={MARKETING_CONTACT_URL} target="_blank" rel="noopener noreferrer">
        Why can&apos;t I see my players?
      </a>
    </Box>
  </SectionWrapper>
);
